import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import styles from "./contact.module.css";
import Container from "react-bootstrap/Container";
import ContactImg from "../../images/contactImg.jpg";

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_dd8m5er",
        "template_qmglsrf",
        e.target,
        "VwcPzqvRjV0VmrIgc"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <Container>
      <section className={styles.scetion__content} id="contact">
        <div className="title">
          <h2>أتصل بنا</h2>
        </div>

        <div className={styles.contact__container}>
          <div className={styles.contact__form}>
            <form className={styles.form} ref={form} onSubmit={sendEmail}>
              <div>
                <label htmlFor="name">الاسم</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="اكتب الاسم"
                  required
                />
              </div>
              <div>
                <label htmlFor="companyName">اسم الشركه</label>
                <input
                  type="text"
                  name="companyName"
                  id="companyName"
                  placeholder="اكتب اسم الشركه"
                />
              </div>
              <div>
                <label htmlFor="email">البريد الاكتروني</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="اكتب البريد الاكتروني"
                />
              </div>
              <div>
                <label htmlFor="phone">رقم الهاتف</label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  placeholder="اكتب رقم الهاتف"
                  required
                />
              </div>
              <div>
                <label htmlFor="message">تفاصيل المطلوب</label>
                <textarea
                  name="message"
                  id="message"
                  placeholder="اكتب تفاصيل المطلوب"
                />
              </div>

              <button className={styles.btn} type="submit">
                إرسال
              </button>
            </form>
          </div>

          <div className={styles.contact__img}>
            <img src={ContactImg} />
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Contact;
